/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Article_EyebrowInputs */

const en_blog_article_eyebrow = /** @type {(inputs: Blog_Article_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the Seek AI journal`)
};

const zh_blog_article_eyebrow = /** @type {(inputs: Blog_Article_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`来自 Seek AI 刊物`)
};

/**
* | output |
* | --- |
* | "From the Seek AI journal" |
*
* @param {Blog_Article_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const blog_article_eyebrow = /** @type {((inputs?: Blog_Article_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Article_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_article_eyebrow(inputs)
	return zh_blog_article_eyebrow(inputs)
});
export { blog_article_eyebrow as "blog.article_eyebrow" }